import { FormIdUtil } from '@onshape/www-inertia';
import UnifiedSignupProgressiveProfile from './UnifiedSignupProgressiveProfile';
import DefaultProgressiveProfile from './DefaultProgressiveProfile';
import { ReferToDiscoProgressiveProfile } from '#components';

const getProgressiveProfile = ({ formId }: { formId: string }) => {
  switch (formId) {
    case FormIdUtil.names.unifiedSignup:
      return new UnifiedSignupProgressiveProfile({ formId });
    case FormIdUtil.names.referToDisco:
      return new ReferToDiscoProgressiveProfile({ formId });
    default:
      return new DefaultProgressiveProfile({ formId });
  }
};

export { getProgressiveProfile };
